import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker, TimePicker } from "@material-ui/pickers";
import { makeStyles, Popover, Tabs, Tab, Button, useMediaQuery, FormControlLabel, Checkbox } from "@material-ui/core";
import { customTheme } from "../customTheme";
import moment from "moment";
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import config from "../config.json";
import { saveTokens } from '../utils/saveTokens';
import notify from './CustomUseNotify';
// import EventNoteIcon from '@material-ui/icons/EventNote';
// import DateRangeIcon from '@material-ui/icons/DateRange';
// import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        columnGap: 10,
        rowGap: 10
    },
    chip: {
        margin: customTheme.spacing(0.5),
        fontFamily: 'Poppins-Medium',
        fontSize: 12
    },
    defaultSelector: {
        borderRadius: 5,
        backgroundColor: "#f2f2f2",
        color: "#888",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        columnGap: 8,
        padding: "0px 20px",
        height: 44
    },
    activeSelector: {
        backgroundColor: customTheme.palette.primary.main + "19",
        color: customTheme.palette.primary.main
    },
    ampmSelector: {
        position: "absolute",
        bottom: 10,
        width: 38,
        height: 38,
        borderRadius: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 15,
        "&:hover": {
            cursor: "pointer"
        }
    }
});

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            hidden={value !== index}
            {...other}
        >
            {value === index && children}
        </div>
    );
}

function DateTimePicker(props) {
    const { initialDateRange, onChange, onDismiss } = props;
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [startDate, setStartDate] = useState(initialDateRange && initialDateRange.startDate ? initialDateRange.startDate : new Date());
    const [endDate, setEndDate] = useState(initialDateRange && initialDateRange.endDate ? initialDateRange.endDate : new Date());
    const [currentPicker, setCurrentPicker] = useState(0);

    const startDateMoment = moment(startDate);
    const endDateMoment = moment(endDate);

    const handleRangeChange = () => {
        onChange({ startDate, endDate });
        onDismiss();
    };

    return (
        <div className="customPickersStyles2 customPicker">
            <Tabs
                value={currentPicker}
                onChange={(event, newValue) => setCurrentPicker(newValue)}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
            >
                <Tab
                    label={<div style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Medium", fontWeight: "normal", letterSpacing: "0.06em" }}>Start: {startDateMoment.format("DD/MM/YYYY")}</div>}
                />
                <Tab
                    label={<div style={{ textTransform: "none", fontSize: 12, fontFamily: "Poppins-Medium", fontWeight: "normal", letterSpacing: "0.06em" }}>End: {endDateMoment.format("DD/MM/YYYY")}</div>}
                />
            </Tabs>
            <TabPanel value={currentPicker} index={0} style={{ display: "flex", flexWrap: isSmallDevice ? 'wrap' : 'nowrap', justifyContent: "center", alignItems: "center" }}>
                <DatePicker
                    disableToolbar
                    variant="static"
                    value={startDate}
                    onChange={setStartDate}
                />
            </TabPanel>
            <TabPanel value={currentPicker} index={1} style={{ display: "flex", flexWrap: isSmallDevice ? 'wrap' : 'nowrap', justifyContent: "center", alignItems: "center" }}>
                <DatePicker
                    disableToolbar
                    variant="static"
                    value={endDate}
                    onChange={setEndDate}
                />
            </TabPanel>
            <div style={{ padding: "8px 10px", textAlign: "right" }}>
                <Button color="inherit" onClick={onDismiss} style={{ marginRight: 10, color: "#666" }}>Cancel</Button>
                <Button color="primary" onClick={handleRangeChange}>Done</Button>
            </div>
        </div >
    );
}


function OnlyTimePicker(props) {
    const classes = useStyles();
    const { initialTime, onChange, onDismiss } = props;
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [currentPicker, setCurrentPicker] = useState(0);

    const initialStartTime = initialTime && initialTime.startTime ? moment(initialTime.startTime, 'HH:mm:ss') : moment('00:00:00', 'HH:mm:ss');
    const initialEndTime = initialTime && initialTime.endTime ? moment(initialTime.endTime, 'HH:mm:ss') : moment('23:59:59', 'HH:mm:ss');

    const [startTime, setStartTime] = useState(initialStartTime)
    const [endTime, setEndTime] = useState(initialEndTime)
    const [saveSummaryStartTime, setSaveSummaryStartTime] = useState(false)

    const startTimeMoment = moment(startTime, 'HH:mm:ss');
    const endTimeMoment = moment(endTime, 'HH:mm:ss');

    const startTimeAm = startTimeMoment.format("A") === "AM";
    const endTimeAm = endTimeMoment.format("A") === "AM";

    const toggleStartDateTimeAmPm = () => {
        startTimeMoment.add(startTimeAm ? 12 : -12, 'h');
        setStartTime(startTimeMoment.toDate());
    };

    const toggleEndDateTimeAmPm = () => {
        endTimeMoment.add(endTimeAm ? 12 : -12, 'h');
        setEndTime(endTimeMoment.toDate());
    };

    const handleRangeChange = () => {
        onChange({ startTime: moment(startTime).format("HH:mm:ss"), endTime: moment(endTime).format("HH:mm:ss") });
        if (saveSummaryStartTime) saveSummaryStartTimeHandler(moment(startTime).format("HH:mm:ss"))
        onDismiss();
    };

    const saveSummaryStartTimeHandler = (summary_start_time) => {
        fetch(`${config.HOST_NAME}/crm/saveSummaryStartTime`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify({ summary_start_time }),
        })
            .then((response) => {
                saveTokens(response)
                return response.json()
            })
            .then((json) => {
                if (json.success) sessionStorage.setItem("summary_start_time", summary_start_time);
                else notify(json.message, 'warning')
            })
            .catch((e) => {
                console.log(e)
            })
    }

    return (
        <div className="customPickersStyles2 customPicker">
            <Tabs
                value={currentPicker}
                onChange={(event, newValue) => setCurrentPicker(newValue)}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
            >
                <Tab
                    label={<div style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Medium", fontWeight: "normal", letterSpacing: "0.06em" }}>
                        Start: {startTimeMoment.format("h:mm:ss A")}
                    </div>}
                />
                <Tab
                    label={<div style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Medium", fontWeight: "normal", letterSpacing: "0.06em" }}>
                        End: {endTimeMoment.format("h:mm:ss A")}
                    </div>}
                />
            </Tabs>
            <TabPanel value={currentPicker} index={0} style={{ display: "flex", flexWrap: isSmallDevice ? 'wrap' : 'nowrap', justifyContent: "center", alignItems: "center" }}>
                <div style={{ position: "relative" }}>
                    <TimePicker
                        disableToolbar
                        variant="static"
                        value={startTime}
                        onChange={setStartTime}
                        views={['hours', 'minutes', 'seconds']}
                    />
                    <div onClick={!startTimeAm ? toggleStartDateTimeAmPm : undefined} className={classes.ampmSelector} style={{ left: 15, color: startTimeAm ? "#fff" : "#222", backgroundColor: startTimeAm ? customTheme.palette.primary.main : customTheme.palette.grey[300] }}>AM</div>
                    <div onClick={startTimeAm ? toggleStartDateTimeAmPm : undefined} className={classes.ampmSelector} style={{ right: 15, color: !startTimeAm ? "#fff" : "#222", backgroundColor: !startTimeAm ? customTheme.palette.primary.main : customTheme.palette.grey[300] }}>PM</div>
                </div>
            </TabPanel>
            <TabPanel value={currentPicker} index={1} style={{ display: "flex", flexWrap: isSmallDevice ? 'wrap' : 'nowrap', justifyContent: "center", alignItems: "center" }}>
                <div style={{ position: "relative" }}>
                    <TimePicker
                        disableToolbar
                        variant="static"
                        value={endTime}
                        onChange={setEndTime}
                        views={['hours', 'minutes', 'seconds']}
                    />
                    <div onClick={!endTimeAm ? toggleEndDateTimeAmPm : undefined} className={classes.ampmSelector} style={{ left: 15, color: endTimeAm ? "#fff" : "#222", backgroundColor: endTimeAm ? customTheme.palette.primary.main : customTheme.palette.grey[300] }}>AM</div>
                    <div onClick={endTimeAm ? toggleEndDateTimeAmPm : undefined} className={classes.ampmSelector} style={{ right: 15, color: !endTimeAm ? "#fff" : "#222", backgroundColor: !endTimeAm ? customTheme.palette.primary.main : customTheme.palette.grey[300] }}>PM</div>
                </div>
            </TabPanel>
            <div style={{ padding: "8px 16px" }}>
                <FormControlLabel
                    control={<Checkbox size="medium" checked={saveSummaryStartTime} onChange={(e) => setSaveSummaryStartTime(e.target.checked)} />}
                    label={<span className='fontWeightSemiBold' style={{ color: "#18CC69", fontSize: 14 }}>Save Summary Time</span>}
                />
            </div>
            <div style={{ padding: "8px 10px", textAlign: "right" }}>
                <Button color="inherit" onClick={onDismiss} style={{ marginRight: 10, color: "#666" }}>Cancel</Button>
                <Button color="primary" onClick={handleRangeChange}>Done</Button>
            </div>
        </div >
    );
}


const CustomDateTimePicker = forwardRef((props, ref) => {
    const { setStartDateTime, setEndDateTime, limitDataRange, showOnlyCustomPicker = false, hideCurrentDate = false, hideCustomDate = false, hideMonthlyDate = false, hideTimeFilter = false, dateTillYesterday = false, showLast30Days = false, defaultTime = true, showLast10Mins = false, style } = props;
    const PIKCER_TYPES = { DATE: "Day", MONTH: "Month", CUSTOM: "Custom" };
    if (hideCurrentDate) delete PIKCER_TYPES.DATE
    if (hideCustomDate) delete PIKCER_TYPES.CUSTOM
    if (hideMonthlyDate) delete PIKCER_TYPES.MONTH
    if (showLast30Days) PIKCER_TYPES.LAST30DAYS = 'Last 30 days'
    if (showLast10Mins) PIKCER_TYPES.LAST10MINS = 'Last 10 Mins'

    const classes = useStyles();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    const [pickerType, setPickerType] = useState(showOnlyCustomPicker ? PIKCER_TYPES.CUSTOM : showLast30Days ? PIKCER_TYPES.LAST30DAYS : showLast10Mins ? PIKCER_TYPES.LAST10MINS : hideCurrentDate && !hideMonthlyDate ? PIKCER_TYPES.MONTH : PIKCER_TYPES.DATE);

    const [dateAnchor, setDateAnchor] = useState(null);
    const [timeAnchor, setTimeAnchor] = useState(null);

    const [justStartDate, setJustStartDate] = useState(null);
    const [justEndDate, setJustEndDate] = useState(null);
    const [justStartTime, setJustStartTime] = useState(null);
    const [justEndTime, setJustEndTime] = useState(null);

    const [maxDate, setMaxDate] = useState(null);

    const closeDatePicker = () => {
        setDateAnchor(null);
    };

    const closeTimePicker = () => {
        setTimeAnchor(null);
    };

    const generateDates = (startTime, endTime, dateM, type = "D", defaultDatesSetter = 0) => {
        const format = 'hh:mm A';
        const dateFormat = 'YYYY-MM-DD';

        const start = moment(startTime, format);
        const end = moment(endTime, format);
        const dateMoment = moment(dateM, dateFormat);

        let reportStartDate = type === "M" ? dateMoment.startOf("month").clone() : dateMoment.clone();
        let reportEndDate = type === "M" ? dateMoment.endOf("month").clone() : dateMoment.clone();

        if (end.isBefore(start) || end.isSame(start)) {
            end.add(1, 'days');
            reportEndDate.add(1, 'days');
        } else if (end.isSame(start) && end.format('A') === 'AM' && start.format('A') === 'AM') {
            reportEndDate.add(1, 'days');
        }

        if (defaultDatesSetter) {
            const dateTimeFormat = 'YYYY-MM-DD hh:mm A';
            const currentDate = moment();
            const currentTime = moment();
            if (currentTime.isBefore(moment(currentDate.format(dateFormat) + ' ' + startTime, dateTimeFormat))) {
                reportStartDate.subtract(1, 'days');
                reportEndDate.subtract(1, 'days');
            }
        }

        setJustStartDate(reportStartDate.format(dateFormat));
        setJustEndDate(reportEndDate.format(dateFormat));
    }

    const setDate = (dateMoment, defaultDatesSetter = 0) => {
        if (showLast30Days) last30DaysHandler()
        else {
            if (justStartTime && justEndTime) generateDates(justStartTime, justEndTime, dateMoment, "D", defaultDatesSetter)
            else {
                const timeStr = sessionStorage.getItem("summary_start_time");
                if (typeof timeStr === "string" && timeStr !== "" && timeStr !== "null" && timeStr !== "undefined" && moment(timeStr, "HH:mm:ss").isValid()) {
                    let hours = 0, minutes = 0, seconds = 0;
                    const timeStr = sessionStorage.getItem("summary_start_time");
                    const parsedTime = moment(timeStr, "HH:mm:ss");
                    hours = parsedTime.hours();
                    minutes = parsedTime.minutes();
                    seconds = parsedTime.seconds();
                    let startTime = `${hours}:${minutes}:${seconds}`
                    generateDates(moment(startTime, 'HH:mm:ss').format('hh:mm A'), moment(startTime, 'HH:mm:ss').add({ hours: 23, minutes: 59, seconds: 59 }).format('hh:mm A'), dateMoment, "D", defaultDatesSetter)
                } else {
                    generateDates("00:00 AM", "11:59 PM", dateMoment, "D", defaultDatesSetter)
                }
            }
        }
    };

    const setTime = (sT, eT) => {
        let startTime = sT
        let hours = 0, minutes = 0, seconds = 0;
        const timeStr = sessionStorage.getItem("summary_start_time");
        if (typeof timeStr === "string" && timeStr !== "" && timeStr !== "null" && timeStr !== "undefined" && moment(timeStr, "HH:mm:ss").isValid()) {
            const parsedTime = moment(timeStr, "HH:mm:ss");
            if (parsedTime.format("HH:mm:ss") === justStartTime) return
            hours = parsedTime.hours();
            minutes = parsedTime.minutes();
            seconds = parsedTime.seconds();
            startTime = `${hours}:${minutes}:${seconds}`
        }
        setJustStartTime(moment(startTime, 'HH:mm:ss').format("HH:mm:ss"))
        setJustEndTime(moment(startTime, 'HH:mm:ss').add({ hours: 23, minutes: 59, seconds: 59 }).format("HH:mm:ss"))
    };

    const setMonth = (dateMoment) => {
        if (justStartTime && justEndTime) generateDates(justStartTime, justEndTime, dateMoment, "M")
        else generateDates("00:00 AM", "11:59 PM", dateMoment, "M")
    };

    const onListItemClick = (type) => {
        setPickerType(type)
        if (showLast30Days && type === 'Last 30 days') {
            last30DaysHandler()
            closeDatePicker()
        }else if(showLast10Mins && type === 'Last 10 Mins'){
            last10MinsHandler()
            closeDatePicker()
        }
    };

    const getDisplayText = () => {
        switch (pickerType) {
            case PIKCER_TYPES.DATE :
                return justStartDate ?
                    moment(justStartDate).calendar(null, {
                        sameDay: '[Today]',
                        nextDay: '[Tomorrow]',
                        nextWeek: "Do MMM' YY",
                        lastDay: '[Yesterday]',
                        lastWeek: "Do MMM' YY",
                        sameElse: "Do MMM' YY"
                    })
                    :
                    moment().calendar(null, {
                        sameDay: '[Today]',
                        nextDay: '[Tomorrow]',
                        nextWeek: "Do MMM' YY",
                        lastDay: '[Yesterday]',
                        lastWeek: "Do MMM' YY",
                        sameElse: "Do MMM' YY"
                    });
            case PIKCER_TYPES.MONTH:
                return justStartDate ? moment(justStartDate).format("MMM' YY") : moment().format("MMM' YY");
            case PIKCER_TYPES.CUSTOM || PIKCER_TYPES.LAST30DAYS :
                return justStartDate && justEndDate ?
                    `${moment(justStartDate).format("DD/MM/YYYY")} - ${moment(justEndDate).format("DD/MM/YYYY")}`
                    :
                    `${moment().set({ hours: 0, minutes: 0, seconds: 0 }).format("DD/MM/YYYY")} - ${moment().set({ hours: 23, minutes: 59, seconds: 59 }).format("DD/MM/YYYY")}`
            case PIKCER_TYPES.LAST10MINS : return 'Last 10 Mins'
            default:
                return PIKCER_TYPES[pickerType]
        }
    };

    const last30DaysHandler = () => {
        setJustStartDate(moment().utcOffset("+05:30").clone().subtract(30, 'days').format("YYYY-MM-DD"));
        setJustEndDate(moment().utcOffset("+05:30").format("YYYY-MM-DD"));
    }

    const last10MinsHandler = () => {
        setJustStartDate(moment().utcOffset("+05:30").format("YYYY-MM-DD"));
        setJustEndDate(moment().utcOffset("+05:30").format("YYYY-MM-DD"));
        setJustStartTime(moment().utcOffset("+05:30").clone().subtract(10, 'minutes').format("HH:mm:ss"))
        setJustEndTime(moment().utcOffset("+05:30").clone().format("HH:mm:ss"))
    }

    const resetFormatByTime = (startTime, endTime, dateM) => {
        if (startTime && endTime && justStartDate) {
            const dateMoment = moment(dateM, "YYYY-MM-DD")
            if (pickerType === PIKCER_TYPES.DATE) generateDates(startTime, endTime, dateMoment)
            if (pickerType === PIKCER_TYPES.MONTH) generateDates(startTime, endTime, dateMoment, "M")
            return
        }
    }

    useEffect(() => {
        if (defaultTime) {
            if (hideCurrentDate && !hideMonthlyDate) {
                setMonth(moment())
                setTime("00:00:00", "23:59:59")
            }
            else if (dateTillYesterday) {
                const yesterday = moment().subtract(1, 'days').toDate()
                setMaxDate(yesterday)
                setDate(yesterday)
                setTime("00:00:00", "23:59:59")
            } else if(showLast10Mins)last10MinsHandler()
            else {
                setMaxDate(moment())
                setDate(moment(), 1)
                setTime("00:00:00", "23:59:59")
            }
            
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        let startDateTimeString = moment(`${justStartDate} ${justStartTime}`, 'YYYY-MM-DD HH:mm:ss')
        let endDateTimeString = moment(`${justEndDate} ${justEndTime}`, 'YYYY-MM-DD HH:mm:ss')

        if (startDateTimeString.isValid()) setStartDateTime(startDateTimeString.format('YYYY-MM-DD HH:mm:ss'))
        if (endDateTimeString.isValid()) setEndDateTime(endDateTimeString.format('YYYY-MM-DD HH:mm:ss'))
    }, [justStartDate, justEndDate, justStartTime, justEndTime]); // eslint-disable-line react-hooks/exhaustive-deps

    useImperativeHandle(ref, () => {
        return {
            refreshTime() {
                if (showLast30Days && pickerType === 'Last 30 days') {
                    last30DaysHandler();
                } else if (showLast10Mins && pickerType === 'Last 10 Mins') {
                    last10MinsHandler();
                }
            }
        };
    }, [showLast30Days, showLast10Mins, pickerType]);

    const displayText = getDisplayText();
    const makeTextScrollable = displayText.length > 12;

    return (<>
        <div style={{ display: "flex", columnGap: 20, margin: isSmallDevice ? "0px 0px 0px 0px" : "0px 0px 0px 0px", padding: isSmallDevice ? "0px 0px" : "0 0", flexWrap: "wrap", rowGap: isSmallDevice ? 10 : 20, ...style }}>
            <div
                onClick={event => setDateAnchor(event.currentTarget)}
                className={`divButton ${classes.defaultSelector} ${classes.activeSelector}`}
            >
                <CalendarTodayIcon style={{ fontSize: 16 }} />

                {!showOnlyCustomPicker && <div className="fontWeightMedium" style={{ fontSize: 12 }}>
                    <div className="scrolling-container" style={{ width: makeTextScrollable ? 80 : "" }}>
                        <div className={makeTextScrollable ? "scrolling-text" : ""}>
                            {displayText}
                        </div>
                    </div>
                </div>}

                {showOnlyCustomPicker && <div className="fontWeightMedium" style={{ fontSize: 12 }}>
                    {pickerType === PIKCER_TYPES.CUSTOM &&
                        justStartDate && justEndDate ?
                        `${moment(justStartDate).format("DD/MM/YYYY")} - ${moment(justEndDate).format("DD/MM/YYYY")}` : `${moment().set({ hours: 0, minutes: 0, seconds: 0 }).format("DD/MM/YYYY h:mm:ss A")} - ${moment().set({ hours: 23, minutes: 59, seconds: 59 }).format("DD/MM/YYYY h:mm:ss A")}`
                    }
                </div>}
            </div>

            {!hideTimeFilter &&
                <div
                    onClick={event => setTimeAnchor(event.currentTarget)}
                    className={`divButton ${classes.defaultSelector} ${classes.activeSelector}`}
                >
                    <CalendarTodayIcon style={{ fontSize: 16 }} />
                    <div className="fontWeightMedium" style={{ fontSize: 12 }}>
                        <div>{moment(justStartTime, 'HH:mm:ss').format("hh:mm A")}</div>
                        <div style={{ marginTop: -5 }}>{moment(justEndTime, 'HH:mm:ss').format("hh:mm A")}</div>
                    </div>
                </div>
            }
        </div>


        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Popover
                open={Boolean(dateAnchor)}
                anchorEl={dateAnchor}
                onClose={closeDatePicker}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                style={{ marginTop: 15, width: isSmallDevice ? "100%" : "auto" }}
                id='custom-date-time-picker-v2'
            >
                <div style={{ display: !isSmallDevice ? 'flex' : 'block', justifyContent: 'flex-start', backgroundColor: '#F5F8FA', padding: !isSmallDevice ? 20 : "20px 20px 150px 20px", columnGap: 20, rowGap: 20 }}>
                    {!isSmallDevice ?
                        <div>
                            {/* <Typography style={{ marginBottom: 10, fontSize:15, textAlign:'center', color: customTheme.palette.primary.main }}>Date Preset</Typography> */}
                            {Object.keys(PIKCER_TYPES).filter((type) => showOnlyCustomPicker && type === 'CUSTOM' ? type : !showOnlyCustomPicker ? type : false).map((value, i) => {
                                return (
                                    <div>
                                        <Button
                                            onClick={() => onListItemClick(PIKCER_TYPES[value])}
                                            variant="contained"
                                            style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", minWidth: "120px", backgroundColor: pickerType === PIKCER_TYPES[value] ? '#707683' : '#FFFFFF', color: pickerType === PIKCER_TYPES[value] ? '#FFFFFF' : "#90A0B7", marginBottom: 20, cursor: 'pointer', height: 45, borderRadius: 10, fontWeight: 500 }}
                                            disableElevation
                                            startIcon={<CalendarTodayIcon style={{ fontSize: 16 }} />}
                                        >
                                            {PIKCER_TYPES[value]}
                                        </Button>
                                    </div>
                                );
                            })}
                        </div>
                        :
                        <div style={{ backgroundColor: '#F5F8FA', padding: 10 }}>
                            {/* <Typography style={{ marginBottom: 10, fontSize: 15, textAlign: 'center', color: customTheme.palette.primary.main }}>Date Preset</Typography> */}
                            <div className={classes.root}>
                                {Object.keys(PIKCER_TYPES).filter((type) => showOnlyCustomPicker && type === 'CUSTOM' ? type : !showOnlyCustomPicker ? type : false).map((value, i) => {
                                    return (
                                        <div>
                                            <Button
                                                onClick={() => onListItemClick(PIKCER_TYPES[value])}
                                                variant="contained"
                                                style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", backgroundColor: pickerType === PIKCER_TYPES[value] ? '#707683' : '#FFFFFF', color: pickerType === PIKCER_TYPES[value] ? '#FFFFFF' : "#90A0B7", marginBottom: 20, cursor: 'pointer', height: 45, borderRadius: 10, fontWeight: 500 }}
                                                disableElevation
                                                startIcon={<CalendarTodayIcon style={{ fontSize: 16 }} />}
                                            >
                                                {PIKCER_TYPES[value]}
                                            </Button>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                    }
                    {pickerType === PIKCER_TYPES.CUSTOM && <DateTimePicker
                        initialDateRange={{ startDate: justStartDate, endDate: justEndDate }}
                        onChange={dateRange => {
                            setJustStartDate(moment(dateRange.startDate).format("YYYY-MM-DD"));
                            setJustEndDate(moment(dateRange.endDate).format("YYYY-MM-DD"));
                            closeDatePicker();
                        }}
                        onDismiss={closeDatePicker}
                    />}
                    {!showOnlyCustomPicker && pickerType === PIKCER_TYPES.MONTH &&
                        <div className="customPickersStyles2 monthPicker">
                            <DatePicker
                                variant="static"
                                minDate={limitDataRange > 0 ? moment().subtract(limitDataRange - 1, "days").toDate() : undefined}
                                disableFuture
                                disableToolbar={pickerType !== PIKCER_TYPES.MONTH}
                                value={justStartDate}
                                onChange={(date) => {
                                    const dateMoment = moment(date);
                                    if (pickerType === PIKCER_TYPES.MONTH) {
                                        setMonth(dateMoment);
                                    }
                                    closeDatePicker();
                                }}
                                views={["month", "year"]}
                            />
                        </div>
                    }
                    {!showOnlyCustomPicker && pickerType === PIKCER_TYPES.DATE &&
                        <div className="customPickersStyles2 datePicker">
                            <DatePicker
                                variant="static"
                                minDate={limitDataRange > 0 ? moment().subtract(limitDataRange - 1, "days").toDate() : undefined}
                                disableFuture
                                disableToolbar={pickerType !== PIKCER_TYPES.MONTH}
                                value={justStartDate}
                                onChange={(date) => {
                                    const dateMoment = moment(date);
                                    if (pickerType === PIKCER_TYPES.DATE) {
                                        setDate(dateMoment);
                                        // setTime("00:00:00", "23:59:59")
                                    }
                                    closeDatePicker();
                                }}
                                views={["year", "month", "date"]}
                                maxDate={maxDate}
                            />
                        </div>
                    }
                </div>
            </Popover>

            {!hideTimeFilter &&
                <Popover
                    open={Boolean(timeAnchor)}
                    anchorEl={timeAnchor}
                    onClose={closeTimePicker}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                    style={{ marginTop: 15, width: isSmallDevice ? "100%" : "auto" }}
                    id='custom-date-time-picker-v2'
                >
                    <div style={{ display: !isSmallDevice ? 'flex' : 'block', justifyContent: 'flex-start', backgroundColor: '#F5F8FA', padding: !isSmallDevice ? 20 : "20px 20px 150px 20px", columnGap: 20, rowGap: 20 }}>
                        <OnlyTimePicker
                            initialTime={{ startTime: justStartTime, endTime: justEndTime }}
                            onChange={timeRange => {
                                setJustStartTime(timeRange.startTime);
                                setJustEndTime(timeRange.endTime);
                                resetFormatByTime(timeRange.startTime, timeRange.endTime, justStartDate)
                                closeTimePicker();
                            }}
                            onDismiss={closeTimePicker}
                        />
                    </div>
                </Popover>
            }
        </MuiPickersUtilsProvider>
    </>);
});
export default CustomDateTimePicker;
